import React from 'react';
import {useParams} from 'react-router-dom';
import {useGetCodingQuestionDetailsQuery} from '../../api/codingChallenge';
import Loader from '../ui/Loader';
import CodingQuestion from './CodingQuestion';

const EditCodingProblem = () => {
  const {problemId} = useParams();

  const {data: questionDetailsResponse, isFetching: isQuestionDetailsLoading} =
    useGetCodingQuestionDetailsQuery(problemId);
  const questionDetails = questionDetailsResponse?.data || null;

  return (
    <>
      {isQuestionDetailsLoading ? (
        <Loader />
      ) : (
        <CodingQuestion
          problemData={questionDetails}
          editMode={true}
          problemId={problemId}
        />
      )}
    </>
  );
};

export default EditCodingProblem;
